import {
  AppBar,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Tooltip,
  Dialog as DialogMui,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
} from '@material-ui/core';
import {
  Menu,
  Info,
  ExitToApp,
  Contactless,
  People,
  MoreHoriz,
  VpnKey,
} from '@material-ui/icons';
import clsx from 'clsx';
import React, { ReactNode, useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { putUserPassword } from '../../../services';
import Context from '../../../context';
// import { Icons } from '../../atoms';
import useStyles from './styles';
import Dialog from '../Dialog';
import { IconLogo } from '../../../assets';

const initFormState = {
  oldPassword: '',
  newPassword: '',
  confirmNewPassword: '',
};

const ModalAccount = ({ open, onClose }: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formState, setFormState] = useState(initFormState);

  const handleChangeForm = (e: any) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (formState.newPassword !== formState.confirmNewPassword) {
      enqueueSnackbar(
        'new password and confirm the new password are not the same',
        { variant: 'error' }
      );
      return;
    }
    try {
      const res = await putUserPassword(1, formState);
      if (res.status === 'error') {
        enqueueSnackbar(res.message, { variant: 'error' });
        return;
      }
      setFormState(initFormState);
      onClose();
      enqueueSnackbar(res.message, { variant: 'success' });
    } catch (err: any) {
      alert(err.message);
    }
  };

  return (
    <DialogMui
      open={open}
      maxWidth='xs'
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>Change Password</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          type='password'
          id='outlined-basic'
          label='Old Password'
          variant='outlined'
          onChange={handleChangeForm}
          value={formState.oldPassword}
          name='oldPassword'
          style={{ marginBottom: 16 }}
        />
        <TextField
          fullWidth
          type='password'
          id='outlined-basic'
          label='New Password'
          variant='outlined'
          onChange={handleChangeForm}
          value={formState.newPassword}
          name='newPassword'
          style={{ marginBottom: 16 }}
        />
        <TextField
          fullWidth
          type='password'
          id='outlined-basic'
          label='Confirm New Password'
          variant='outlined'
          onChange={handleChangeForm}
          value={formState.confirmNewPassword}
          name='confirmNewPassword'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} color='primary' autoFocus>
          Save
        </Button>
      </DialogActions>
    </DialogMui>
  );
};

const dataMenu: any = [
  {
    path: '/dashboard',
    text: 'Tentang Kami',
    icon: <Info />,
  },
  {
    path: '/dashboard/jalan-tol-kami',
    text: 'Jalan Tol Kami',
    icon: <People />,
  },
  // {
  //   path: "/dashboard/fasilitas",
  //   text: "Armada & Perlengkapan Operasi",
  //   icon: <Business />,
  // },
  {
    path: '/dashboard/ruang-berita',
    text: 'Ruang Berita',
    icon: <Contactless />,
  },
  {
    path: '/dashboard/lainnya',
    text: 'Lainnya',
    icon: <MoreHoriz />,
  },
  // {
  //   path: "/dashboard/pengumuman",
  //   text: "Pengumuman",
  //   icon: <Contactless />,
  // },
  // {
  //   path: "/dashboard/hubungi-kami",
  //   text: "Hubungi Kami",
  //   icon: <MoreHoriz />,
  // },
  // {
  //   path: "/dashboard/images",
  //   text: "Images",
  //   icon: <Image />,
  // },
];

const LayoutDashboard = (props: { children: ReactNode }) => {
  const location = useLocation<any>();
  const history = useHistory();
  const classes = useStyles();
  const context = React.useContext(Context);
  const dialog = context.dialog;
  const [drawerState, setDrawerState] = React.useState(true);
  const [dialogAccount, setDialogAccount] = React.useState(false);

  const handleDrawerOpen = () => {
    setDrawerState(true);
  };

  const handleCloseDialogAccount = () => {
    setDialogAccount(false);
  };

  return (
    <div className={classes.root}>
      <ModalAccount open={dialogAccount} onClose={handleCloseDialogAccount} />
      <Dialog
        open={dialog.open}
        title={dialog.title}
        text={dialog.text}
        handleAgree={dialog.handleAgree}
        handleClose={context.closeDialog}
      />
      <CssBaseline />
      <AppBar
        position='fixed'
        className={clsx(classes.appBar, {
          [classes.appBarShift]: drawerState,
        })}
      >
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            edge='start'
            className={clsx(classes.menuButton, {
              [classes.hide]: drawerState,
            })}
          >
            <Menu />
          </IconButton>
          <Typography variant='h6' noWrap>
            {!location.state ? 'Beranda' : location.state.title}
          </Typography>
          <div className={classes.logoutIcon}>
            <Tooltip title='Password' aria-label='Password'>
              <IconButton
                color='inherit'
                aria-label='Profile'
                onClick={() => setDialogAccount(true)}
              >
                <VpnKey />
              </IconButton>
            </Tooltip>
            <Tooltip title='Logout' aria-label='Logout'>
              <IconButton
                color='inherit'
                aria-label='logout'
                onClick={() => {
                  localStorage.removeItem('token');
                  history.push('/dashboard/login');
                }}
              >
                <ExitToApp />
              </IconButton>
            </Tooltip>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        variant='permanent'
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: drawerState,
          [classes.drawerClose]: !drawerState,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: drawerState,
            [classes.drawerClose]: !drawerState,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <div className={classes.logoContainer}>
            <IconLogo style={{ width: 200 }} />
          </div>
        </div>
        <Divider />
        <List>
          {dataMenu.map((row: any, index: any) => (
            <ListItem
              button
              key={index}
              component={Link}
              to={{
                pathname: row.path,
                state: { title: row.text },
              }}
              selected={location.pathname === row.path}
              style={{ whiteSpace: 'break-spaces' }}
            >
              <ListItemIcon>{row.icon}</ListItemIcon>
              <ListItemText primary={row.text} />
            </ListItem>
          ))}
          <Divider />
          <ListItem button component={Link} to='/dashboard/login'></ListItem>
        </List>
        <div className={classes.copyright}>
          <Typography variant='body2' color='textSecondary' align='center'>
            Copyright © 2021
          </Typography>
          <Typography variant='body2' color='textSecondary' align='center'>
            Jakarta TollRoad Development
          </Typography>
          <Typography variant='body2' color='textSecondary' align='center'>
            All Rights Reserved.
          </Typography>
        </div>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
};

export default LayoutDashboard;
